<template>
  <el-card>
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-input :value="deviceNumber" disabled></el-input>
      </el-form-item>
      <el-form-item prop="dateRange">
        <el-date-picker
          :clearable = "false"
          v-model="searchInfo.dateRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" v-loading="loading" :data="dataList">
      <el-table-column label="上报时间" prop="collectTime" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="运行状态" prop="switchStatus" min-width="100" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{row.switchStatus === '1' ? '开启' : row.switchStatus === '0' ? '关闭' : ''}}
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      @size-change="getData"
      @current-change="getData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>
  </el-card>
</template>

<script>
export default {
  name: 'MowingHistory',
  data () {
    return {
      searchInfo: {
        dateRange: []
      },
      selectTime: 0,
      pickerOptions: {
        // 选中日期后会执行的回调
        onPick: (date) => {
          this.selectTime = date.minDate.getTime()
          if (date.maxDate) {
            this.selectTime = 0
          }
        },
        disabledDate: (time) => {
          if (this.selectTime !== 0) {
            const dayTime = 29 * 24 * 3600 * 1000
            const minTime = this.selectTime - dayTime
            const maxTime = this.selectTime + dayTime
            return (time.getTime() < minTime || time.getTime() > maxTime)
          }
        }
      },
      loading: false,
      dataList: [],
      page: 1,
      size: 10,
      total: 0
    }
  },
  computed: {
    deviceNumber () {
      return this.$route.params.deviceNumber
    }
  },
  created () {
    this.initTime()
    this.getData()
  },
  mounted () {
    window.addEventListener('resize', this.resize)
  },
  destroyed () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    initTime () {
      const val = this.$dayjs().format('YYYY-MM-DD')
      const vals = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      this.searchInfo.dateRange = [vals, val]
    },
    getData () {
      if (this.searchInfo.dateRange && this.searchInfo.dateRange[0]) {
        this.loading = true
        this.$axios.get(this.$apis.iot.selectJgSprayDataByPage, {
          deviceNumber: this.deviceNumber,
          startTime: this.searchInfo.dateRange[0],
          endTime: this.searchInfo.dateRange[1],
          page: this.page,
          size: this.size
        }).then((res) => {
          this.total = res.total || 0
          this.dataList = res.list || []
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$message.error('请选择查询日期范围')
      }
    },
    onSearch () {
      this.page = 1
      this.getData()
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
